import { Outlet, useNavigate } from 'react-router-dom';

import { useState, useEffect } from 'react'
import { LeftNav } from '@/components/layout/LeftNav';

export const HomePageV2 = () => {
	const navigate = useNavigate();
	const [selectedSection, setSelectedSection] = useState("overview");

	const handleNavSelect = (id: string) => {
		setSelectedSection(id);

		// special consideration for 'overview' which should resolve to '/'
		navigate(id === "overview" ? '/' : `/${id}`);
	};

	// keep the selected section (page) in sync with the site location
	useEffect(() => {
		const path = location.pathname.replace("/", "");
		setSelectedSection(path === '' ? 'overview' : path);
	}, [location.pathname])

	return (
		<div className='flex flex-row overflow-hidden w-full h-full'>
			<div className='flex flex-row h-full p-4'>
				<LeftNav selectedId={selectedSection} onSelect={handleNavSelect} className='hidden lg:block w-60 bg-[#0C0F1D]/70 backdrop-blur-md border-2 border-black' />
			</div>
			<Outlet />
		</div>
	)
}